import RoboSpinner from './RoboSpinner';

export default RoboSpinner;
